import Item from 'common/ITEMS/Item';

const items = {
  //region Arms
  //endregion
  //region Fury
  //endregion
  //region Protection
  //endregion
  //region Shared
  //endregion
} satisfies Record<string, Item>;
export default items;
